import React from 'react';
import { Fade } from '@material-ui/core';
import { POPUP_TYPE, FadeInAndOutDuration, HeadingColor } from './constant';
import './styles.css';

export const Popup = ({
  open = false,
  title: heading,
  children: content,
  type = POPUP_TYPE.INFO,
}) => {
  return (
    <Fade in={open} timeout={FadeInAndOutDuration}>
      <div className='popup-container flex align-items-center justify-content-center'>
        <div className='flex flex-column bg-white p-5 m-l-5 m-r-5'>
          <div className='popup-heading flex align-items-center m-b-5'>
            <p className={`font-16 bold font-roboto m-0 ${HeadingColor.get(type)}`}>{heading}</p>
          </div>
          <div className='popup-content'>{content}</div>
        </div>
      </div>
    </Fade>
  );
};

export default Popup;
